import React from "react";
import { Link } from "react-router-dom";
import { useI18n } from "@/contexts/I18nContext";
import { usePageMeta } from "@/lib/usePageMeta";

/** Full-page "not found", used by the catch-all route and by detail pages on a 404. */
export const NotFoundState = () => {
  const { t } = useI18n();
  usePageMeta({ title: t("not_found_title"), noindex: true });
  return (
    <div className="max-w-xl mx-auto px-4 py-20 text-center" data-testid="not-found">
      <p className="text-6xl font-serif-hi text-primary/70">404</p>
      <h1 className="mt-4 text-2xl sm:text-3xl font-serif-hi">{t("not_found_title")}</h1>
      <p className="mt-3 text-muted-foreground">{t("not_found_body")}</p>
      <div className="mt-8 flex flex-wrap justify-center gap-3">
        <Link to="/" className="inline-flex items-center bg-primary text-primary-foreground px-5 py-2.5 rounded-sm text-sm hover:bg-primary/90">
          {t("go_home")}
        </Link>
        <Link to="/books" className="inline-flex items-center border border-border px-5 py-2.5 rounded-sm text-sm hover:border-primary/50">
          {t("all_books")}
        </Link>
      </div>
    </div>
  );
};

/** Inline error with a retry, for failed loads (network down, 5xx). */
export const ErrorState = ({ onRetry }) => {
  const { t } = useI18n();
  return (
    <div className="max-w-xl mx-auto px-4 py-16 text-center" role="alert" data-testid="error-state">
      <h2 className="text-xl font-serif-hi">{t("error_title")}</h2>
      <p className="mt-2 text-sm text-muted-foreground">{t("error_body")}</p>
      {onRetry && (
        <button onClick={onRetry} className="mt-6 border border-border px-5 py-2 rounded-sm text-sm hover:border-primary/50">
          {t("retry")}
        </button>
      )}
    </div>
  );
};
